import { GroupFoodDrink } from '@shared/api/types';
import { HeaderCell } from '@shared/components/data-table/cells/header-cell';
import RatingCloud, {
  RatingCloudProps,
} from '@shared/components/ratings/rating-cloud';
import { ColumnDef } from '@tanstack/react-table';
import {
  FilterOption,
  getLeadingColumns,
  getTrailingColumns,
} from './group-purchased-goods-columns';
import { GroupFoodAndDrinkFilterColumn } from './group-food-and-drink-table-filters';

interface UseColumnsArgs {
  ratingOptions: FilterOption[];
  familyOptions: FilterOption[];
  supplierOptions: FilterOption[];
}

export function useGroupFoodAndDrinkColumns({
  ratingOptions,
  familyOptions,
  supplierOptions,
}: UseColumnsArgs): ColumnDef<GroupFoodDrink>[] {
  return [
    ...getLeadingColumns<GroupFoodDrink>(),
    {
      id: GroupFoodAndDrinkFilterColumn.Rating,
      accessorFn: (row) => row.emissionsCategory,
      size: 80,
      header: ({ column }) => <HeaderCell column={column} name="Rating" />,
      cell: ({ getValue }) => {
        const rating = getValue<RatingCloudProps['rating'] | null>();
        if (!rating) return null;
        return <RatingCloud rating={rating} />;
      },
      enableSorting: false,
      enableColumnFilter: true,
      meta: {
        label: 'Rating',
        variant: 'multiSelect',
        options: ratingOptions,
        sorting: { ascLabel: 'A-Z', descLabel: 'Z-A' },
      },
    },
    ...getTrailingColumns<GroupFoodDrink>(),
    // Filter-only columns. Hidden but registered with tanstack so the toolbar
    // can route faceted filter changes through them. (Search lives on the
    // visible Item column in `getLeadingColumns`.)
    {
      id: GroupFoodAndDrinkFilterColumn.Family,
      accessorFn: () => null,
      enableColumnFilter: true,
      meta: {
        label: 'Family',
        variant: 'multiSelect',
        options: familyOptions,
        sorting: { ascLabel: 'A-Z', descLabel: 'Z-A' },
      },
    },
    {
      id: GroupFoodAndDrinkFilterColumn.Supplier,
      accessorFn: () => null,
      enableColumnFilter: true,
      meta: {
        label: 'Supplier',
        variant: 'multiSelect',
        options: supplierOptions,
        sorting: { ascLabel: 'A-Z', descLabel: 'Z-A' },
      },
    },
  ];
}
